import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ExpertLoader = lazyWithPreload(() => import('./ExpertLoader'))
